module.exports = __webpack_public_path__ + "img/order-empty.1aac5bdb.png";